
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11475',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11475",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "dashboard-client-types": "static-1.209",
  "data-fetching-client": "static-1.9452",
  "foundations-components": "static-1.7475",
  "foundations-components-legacy": "static-1.500",
  "foundations-theming": "static-1.4183",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7779",
  "hub-http-shared-msw-handlers": "static-1.9414",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11196",
  "I18n": "static-7.1562",
  "jasmine-runner": "static-1.6246",
  "marketplace-storefront-base": "static-1.11535",
  "quartz": "static-1.6690",
  "react-dlb": "static-1.71",
  "react-rhumb": "static-1.16415",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2636",
  "reporting-testing-lib": "static-1.8336",
  "settings-ui-lib": "static-1.12294",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6678",
  "ui-addon-i18n": "static-1.10906",
  "ui-addon-react-router-dom": "static-1.9322",
  "unified-auth": "static-1.168",
  "unified-auth-core-lib": "static-1.449",
  "usage-tracker": "static-1.7106",
  "usage-tracker-core": "static-1.6956",
  "customer-data-property-utils": "static-1.7845",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15330",
  "marketplace-ui-common": "static-1.18869",
  "property-management-iframe": "static-1.12211",
  "quartz-config": "static-1.468",
  "quartz-core": "static-1.5909",
  "quartz-routing": "static-1.120",
  "quick-fetch": "static-1.3709",
  "react": "static-7.177",
  "rpc-client-utils": "static-1.4406",
  "ts-schema": "static-1.3880",
  "ui-universal-auth": "static-1.8654",
  "UIComponents": "static-3.8143",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3204",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2967",
  "quartz-webpack": "static-1.2914",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3744",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4607",
  "foundations-theming-specialty": "static-1.1899",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9202",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5149",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.483",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1120",
  "ui-fonts": "static-1.458",
  "ui-images": "static-2.1085",
  "bend-plugin-foundations-theming": "static-1.2666",
  "foundations-theming-base": "static-1.3168",
  "stylex": "static-1.27",
  "HeadJS": "static-2.704",
  "hs-test-utils-bend-plugin": "static-1.2890",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4103",
  "ai-components-ui-library": "static-1.8279",
  "ai-rendering-library": "static-1.9221",
  "chirp-fetch": "static-1.1658",
  "connections-embed-lib": "static-1.588",
  "copilot-toolkit": "static-1.10455",
  "laboratory-lib": "static-3.6936",
  "marketplace-embed": "static-1.21408",
  "marketplace-ui-details": "static-1.8765",
  "marketplace-ui-reviews": "static-1.18825",
  "marketplace-ui-tracking": "static-1.13040",
  "sanitize-text": "static-1.7914",
  "ui-addon-video-player": "static-1.8470",
  "usage-tracker-multi": "static-1.5520",
  "usage-tracker-session-replay": "static-1.4792",
  "wootric-nps": "static-1.6756",
  "apollo-link-hub-http": "static-2.4422",
  "immer": "static-1.33",
  "immerable": "static-1.3928",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2380",
  "reporting-data": "static-1.66403",
  "cssUtils": "static-1.725",
  "flux-actions": "static-1.304",
  "HubStyle": "static-2.11504",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.9985",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10146",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7096",
  "icons": "static-2.618",
  "marketplace-ui-apps-core": "static-1.17402",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4297",
  "foundations-components-test-utils": "static-1.4958",
  "quartz-i18n": "static-1.365",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3505",
  "customer-data-objects": "static-1.7417",
  "property-translator": "static-1.5187",
  "frontend-preferences-client": "static-1.7698",
  "hs-promise-utils": "static-1.5365",
  "hubspot-apollo-client": "static-1.4653",
  "integrations-error-boundary-lib": "static-1.12745",
  "integrations-tracking-lib": "static-1.5358",
  "native-integrations-shared-strings": "static-1.7562",
  "reselect": "static-2.16",
  "sanitize": "static-1.4248",
  "superstore": "static-1.4545",
  "ui-shepherd-react": "static-3.9918",
  "ai-settings-ui-library": "static-1.7371",
  "hub-http-janus": "static-1.787",
  "hubspotter-http": "static-1.4453",
  "immutable-less": "static-1.4427",
  "marketplace-ui-client-types": "static-1.16276",
  "nav-meta": "static-1.28822",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10010",
  "ui-addon-upgrades": "static-9.17613",
  "inbound-db-properties-service-client": "static-1.3651",
  "property-management-common": "static-1.4498",
  "ui-addon-iframeable": "static-1.8816",
  "dispatcher": "static-1.131",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.477",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.365",
  "quartz-head": "static-1.355",
  "quartz-test": "static-1.365",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2912",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20206",
  "ContentUtils": "static-1.67547",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2259",
  "customer-data-filters-ui": "static-1.38789",
  "customer-data-objects-ui-components": "static-1.12778",
  "customer-data-reference-ui-components": "static-1.12915",
  "embedded-academy-lib": "static-1.13408",
  "ExportDialog": "static-6.10162",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40590",
  "reporting-snowflake": "static-1.55021",
  "reporting-ui-components": "static-2.63674",
  "reporting-visualizations": "static-1.58479",
  "ui-addon-teams": "static-1.21204",
  "magpie-lib": "static-1.5368",
  "magpie-types": "static-1.4828",
  "simple-logging-lib": "static-1.2824",
  "navigation-components": "static-1.17185",
  "ai-studio-lib": "static-1.10921",
  "developer-experience-shared-components": "static-1.10242",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7758",
  "ui-tool-access": "static-1.9917",
  "usage-based-billing-components-lib": "static-1.7938",
  "usage-tracker-anonymous": "static-1.5523",
  "usage-tracker-public": "static-1.6917",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3481",
  "reference-resolvers": "static-1.7934",
  "ui-extensibility-client-types": "static-1.3721",
  "hubspot-apollo-cache": "static-1.112",
  "universal-page-editor-lib": "static-1.2770",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2109",
  "merchandise-lib": "static-1.258",
  "atom": "static-1.4844",
  "purchase-motions-components": "static-1.5447",
  "salesImages": "static-1.520",
  "upgrade-management-service-types": "static-1.4282",
  "batch-promise": "static-1.1324",
  "crm-component-utils": "static-1.38421",
  "crm-properties-common-lib": "static-1.5645",
  "framework-data-schema-resolvers": "static-1.6644",
  "reference-resolvers-lite": "static-1.7864",
  "navigation-messaging": "static-1.6512",
  "hubspotter-http-shared-msw-handlers": "static-1.9412",
  "cms-field-types": "static-1.4579",
  "content-icons-ui": "static-1.2146",
  "conversations-skeleton-state": "static-1.7023",
  "crm-message-bus": "static-1.42272",
  "customer-data-filters-ui-msw-helpers": "static-1.21223",
  "customer-data-ui-utilities": "static-1.9597",
  "FormUrlGenerator": "static-2.4504",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6549",
  "multi-account-reference-resolvers": "static-1.743",
  "onboarding-tours": "static-1.16221",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.12976",
  "academy-common-lib": "static-1.12868",
  "content-assistance-lib": "static-1.7411",
  "dashboard-lib": "static-1.80521",
  "file-manager-components": "static-1.22812",
  "getting-started-shared-tasks": "static-1.17804",
  "hubspot-prosemirror": "static-1.17532",
  "hubspot-prosemirror-plugins": "static-1.17524",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19429",
  "share-with-third-party-component-lib": "static-1.8465",
  "ui-addon-draggable": "static-3.4539",
  "ui-asset-management-lib": "static-1.10673",
  "ui-business-units-lib": "static-1.8799",
  "user-context": "static-1.4868",
  "growth-payments-core": "static-1.24648",
  "reporting-plugins": "static-1.9948",
  "reporting-reports": "static-1.66081",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.500",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28805",
  "react-codemirror": "static-1.10400",
  "apps-service-types": "static-1.3653",
  "oauth-service-types": "static-1.4015",
  "onboarding-scopes": "static-1.6237",
  "onboarding-tours-client": "static-1.4435",
  "platform-infra-nav-components": "static-1.7469",
  "subscription-experience-data-types": "static-1.14554",
  "crm-record-cards-service-types": "static-1.3428",
  "location-customization-utils-lib": "static-1.8471",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4298",
  "nav-client-types": "static-1.2130",
  "purchase-motions-api": "static-1.5450",
  "signup-constants": "static-1.18337",
  "signup-ui-url-generator": "static-2.7839",
  "trials-service-types": "static-1.3699",
  "card-properties-lib": "static-1.43445",
  "crm-actions": "static-1.6070",
  "crm-cards-data": "static-1.1156",
  "crm-cards-sdk": "static-1.42831",
  "customer-data-properties": "static-1.50717",
  "customer-data-properties-shared-msw-handlers": "static-1.8741",
  "customer-data-tracking": "static-1.6655",
  "conditional-properties-service-client": "static-1.3600",
  "crm-pipelines-api-client-types": "static-1.3940",
  "multi-currency-client-types": "static-1.3494",
  "external-options-client-types": "static-1.3960",
  "react-dnd-compat": "static-1.4396",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5125",
  "growth-onboarding-confetti": "static-1.2844",
  "growth-onboarding-next-action-utils": "static-1.1269",
  "onboarding-tours-utils": "static-1.287",
  "ui-shepherd-tracker": "static-1.7299",
  "academy-service-client": "static-1.3456",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27874",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8159",
  "video-components-external": "static-1.10488",
  "video-data-lib": "static-1.34146",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8343",
  "payment-link-components": "static-1.22867",
  "ui-addon-emoji-picker": "static-1.9662",
  "EmailSignatureEditor": "static-1.23859",
  "viral-links-lib": "static-1.6804",
  "data-token-picker": "static-1.16000",
  "FileManagerLib": "static-1.38452",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5018",
  "getting-started-shared-tasks-store": "static-1.16922",
  "campaign-roi-lib": "static-1.8186",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.165",
  "eligibility-engine-service-types": "static-1.2980",
  "crm_data": "static-4.91129",
  "crm-links": "static-1.6029",
  "customer-data-sidebar": "static-2.45341",
  "enrichment-properties-lib": "static-1.14895",
  "crm-fe-perf": "static-1.22680",
  "calling-global-api": "static-1.63562",
  "calling-internal-common": "static-1.31067",
  "calling-lifecycle-internal": "static-1.64944",
  "calling-lifecycle-messages": "static-1.57238",
  "commerce-products-lib": "static-1.8778",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.447",
  "inbounddb-objects-service-types": "static-1.4026",
  "meetings-icalendar-utils-lib": "static-1.407",
  "object-builder-ui-client": "static-1.47878",
  "pipeline-validation-client-types": "static-1.3762",
  "property-value-citations": "static-1.1331",
  "pulse": "static-1.279",
  "smart-property-lib": "static-1.5777",
  "tiered-pricing": "static-1.788",
  "ui-addon-form-validation": "static-1.10768",
  "growth-onboarding-feedback-components": "static-1.6359",
  "content-media-composition-data-lib": "static-1.11353",
  "content-media-compositions": "static-2.15360",
  "media-bridge-lib": "static-1.18523",
  "commerce-tours-lib": "static-1.5678",
  "growth-onboarding-reliability": "static-1.4862",
  "sales-checkout-service-client": "static-1.3452",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21266",
  "sales-email-signature-service-client": "static-1.3619",
  "audio-components": "static-1.5575",
  "FileManagerCore": "static-1.38311",
  "FileManagerImages": "static-1.35963",
  "video-components": "static-1.12491",
  "crm_universal": "static-1.21619",
  "customer-data-email": "static-1.17626",
  "calling-error-reporting": "static-1.31073",
  "card-payment-highlight-lib": "static-1.36424",
  "card-subscription-highlight-lib": "static-1.38783",
  "commerce-billing-lib": "static-1.18424",
  "commerce-contract-lib": "static-1.11060",
  "customer-data-content": "static-1.26829",
  "invoices-highlight-card-lib": "static-1.53924",
  "orders-highlight-card-lib": "static-1.20808",
  "products-highlight-card-lib": "static-1.17062",
  "project-storage": "static-1.4506",
  "quotes-highlight-card-lib": "static-1.71055",
  "breeze-intelligence-kit": "static-1.5283",
  "crm-source-interpretation-lib": "static-1.5102",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9497",
  "policy-lib": "static-1.6555",
  "shared-worker-versioning": "static-1.10810",
  "calling-usage-tracker": "static-1.6312",
  "voice-sms-access-library": "static-1.163",
  "products-iframe-lib": "static-1.7245",
  "products-ui-components-shared-msw-handlers": "static-1.9796",
  "directed-graph": "static-1.711",
  "event-emitter": "static-1.721",
  "react-tinymce": "static-1.54548",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9560",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53674",
  "tinymce-plugins": "static-1.56788",
  "tinymce-themes": "static-1.55644",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4308",
  "video-embed": "static-1.34980",
  "social-insights-client-types": "static-1.21265",
  "sequences-lib": "static-1.7649",
  "ui-gdpr-components": "static-1.10121",
  "commerce-shared-components-lib": "static-1.17848",
  "commerce-subscription-lib": "static-1.36360",
  "commerce-tools-ui-lib": "static-1.9727",
  "utility-belt": "static-1.2316",
  "payments-enrollment-embed-lib": "static-1.21904",
  "products-ui-components": "static-1.39297",
  "quotes-client-types": "static-1.37143",
  "quotes-ui-lib": "static-1.79774",
  "SalesContentIndexUI": "static-3.8862",
  "accounting-integrations-ui-components": "static-1.6685",
  "invoices-ui-lib": "static-1.53940",
  "commerce-products-api": "static-1.1919",
  "SafeStorage": "static-1.4178",
  "invoices-iframe-lib": "static-1.55998",
  "quotes-modal-lib": "static-1.101731",
  "calling-orchestration-schema": "static-1.34940",
  "sales-views-client-types": "static-1.4066",
  "hub-http-contrib": "static-1.2818",
  "interframe": "static-3.4565",
  "tinymce-data": "static-1.39759",
  "ui-addon-sales-email": "static-1.4987",
  "layout-dnd-components": "static-1.11984",
  "layout-dnd-utils": "static-1.10959",
  "ui-brand-identity-lib": "static-1.13738",
  "NamespacedHubStyle": "static-2.8872",
  "outpost": "static-1.3980",
  "sequences-client-types-lib": "static-1.7506",
  "customer-data-associations": "static-1.7109",
  "framework-data-table": "static-2.11350",
  "customer-data-rte": "static-1.32384",
  "cv-backend-services": "static-1.1490",
  "growth-onboarding-empty-states": "static-1.5326",
  "InboxConnectUtils": "static-4.14154",
  "payments-post-enroll-local-storage-lib": "static-1.4886",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7090",
  "commerce-permissions": "static-1.526",
  "commerce-tax-lib": "static-1.283",
  "property-description-translator": "static-1.3633",
  "FireAlarmUi": "static-1.4303",
  "sales-templates-service-types-lib": "static-1.3970",
  "commerce-analytics-service-client": "static-1.3440",
  "totals-ui-components": "static-1.22933",
  "ContentData": "static-1.67622",
  "layout-data-lib": "static-1.9284",
  "deal-intel-decorators": "static-1.1158",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27652",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3614",
  "advanced-menus-core": "static-1.14778",
  "advanced-menus-lib": "static-1.11758",
  "ui-memberships-settings-lib": "static-1.33357",
  "deal-intel-utils": "static-1.1162",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14777",
  "simple-menus-lib": "static-1.16294"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11475",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "dashboard-client-types": "/dashboard-client-types/static-1.209",
  "data-fetching-client": "/data-fetching-client/static-1.9452",
  "foundations-components": "/foundations-components/static-1.7475",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.500",
  "foundations-theming": "/foundations-theming/static-1.4183",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7779",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9414",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11196",
  "I18n": "/I18n/static-7.1562",
  "jasmine-runner": "/jasmine-runner/static-1.6246",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11535",
  "quartz": "/quartz/static-1.6690",
  "react-dlb": "/react-dlb/static-1.71",
  "react-rhumb": "/react-rhumb/static-1.16415",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2636",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8336",
  "settings-ui-lib": "/settings-ui-lib/static-1.12294",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6678",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10906",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9322",
  "unified-auth": "/unified-auth/static-1.168",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.449",
  "usage-tracker": "/usage-tracker/static-1.7106",
  "usage-tracker-core": "/usage-tracker-core/static-1.6956",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7845",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15330",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18869",
  "property-management-iframe": "/property-management-iframe/static-1.12211",
  "quartz-config": "/quartz-config/static-1.468",
  "quartz-core": "/quartz-core/static-1.5909",
  "quartz-routing": "/quartz-routing/static-1.120",
  "quick-fetch": "/quick-fetch/static-1.3709",
  "react": "/react/static-7.177",
  "rpc-client-utils": "/rpc-client-utils/static-1.4406",
  "ts-schema": "/ts-schema/static-1.3880",
  "ui-universal-auth": "/ui-universal-auth/static-1.8654",
  "UIComponents": "/UIComponents/static-3.8143",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3204",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2967",
  "quartz-webpack": "/quartz-webpack/static-1.2914",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3744",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4607",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1899",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9202",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5149",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1120",
  "ui-fonts": "/ui-fonts/static-1.458",
  "ui-images": "/ui-images/static-2.1085",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2666",
  "foundations-theming-base": "/foundations-theming-base/static-1.3168",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.704",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2890",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4103",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8279",
  "ai-rendering-library": "/ai-rendering-library/static-1.9221",
  "chirp-fetch": "/chirp-fetch/static-1.1658",
  "connections-embed-lib": "/connections-embed-lib/static-1.588",
  "copilot-toolkit": "/copilot-toolkit/static-1.10455",
  "laboratory-lib": "/laboratory-lib/static-3.6936",
  "marketplace-embed": "/marketplace-embed/static-1.21408",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8765",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18825",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13040",
  "sanitize-text": "/sanitize-text/static-1.7914",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8470",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5520",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4792",
  "wootric-nps": "/wootric-nps/static-1.6756",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4422",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3928",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2380",
  "reporting-data": "/reporting-data/static-1.66403",
  "cssUtils": "/cssUtils/static-1.725",
  "flux-actions": "/flux-actions/static-1.304",
  "HubStyle": "/HubStyle/static-2.11504",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.9985",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10146",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7096",
  "icons": "/icons/static-2.618",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17402",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4297",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4958",
  "quartz-i18n": "/quartz-i18n/static-1.365",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3505",
  "customer-data-objects": "/customer-data-objects/static-1.7417",
  "property-translator": "/property-translator/static-1.5187",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7698",
  "hs-promise-utils": "/hs-promise-utils/static-1.5365",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4653",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12745",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5358",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7562",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4248",
  "superstore": "/superstore/static-1.4545",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9918",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7371",
  "hub-http-janus": "/hub-http-janus/static-1.787",
  "hubspotter-http": "/hubspotter-http/static-1.4453",
  "immutable-less": "/immutable-less/static-1.4427",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16276",
  "nav-meta": "/nav-meta/static-1.28822",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10010",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17613",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3651",
  "property-management-common": "/property-management-common/static-1.4498",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8816",
  "dispatcher": "/dispatcher/static-1.131",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.477",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.365",
  "quartz-head": "/quartz-head/static-1.355",
  "quartz-test": "/quartz-test/static-1.365",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2912",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20206",
  "ContentUtils": "/ContentUtils/static-1.67547",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2259",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38789",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12778",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12915",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13408",
  "ExportDialog": "/ExportDialog/static-6.10162",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40590",
  "reporting-snowflake": "/reporting-snowflake/static-1.55021",
  "reporting-ui-components": "/reporting-ui-components/static-2.63674",
  "reporting-visualizations": "/reporting-visualizations/static-1.58479",
  "ui-addon-teams": "/ui-addon-teams/static-1.21204",
  "magpie-lib": "/magpie-lib/static-1.5368",
  "magpie-types": "/magpie-types/static-1.4828",
  "simple-logging-lib": "/simple-logging-lib/static-1.2824",
  "navigation-components": "/navigation-components/static-1.17185",
  "ai-studio-lib": "/ai-studio-lib/static-1.10921",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10242",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7758",
  "ui-tool-access": "/ui-tool-access/static-1.9917",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7938",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5523",
  "usage-tracker-public": "/usage-tracker-public/static-1.6917",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3481",
  "reference-resolvers": "/reference-resolvers/static-1.7934",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3721",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.112",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2770",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2109",
  "merchandise-lib": "/merchandise-lib/static-1.258",
  "atom": "/atom/static-1.4844",
  "purchase-motions-components": "/purchase-motions-components/static-1.5447",
  "salesImages": "/salesImages/static-1.520",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4282",
  "batch-promise": "/batch-promise/static-1.1324",
  "crm-component-utils": "/crm-component-utils/static-1.38421",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5645",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6644",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7864",
  "navigation-messaging": "/navigation-messaging/static-1.6512",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9412",
  "cms-field-types": "/cms-field-types/static-1.4579",
  "content-icons-ui": "/content-icons-ui/static-1.2146",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7023",
  "crm-message-bus": "/crm-message-bus/static-1.42272",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21223",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9597",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4504",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6549",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.743",
  "onboarding-tours": "/onboarding-tours/static-1.16221",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12976",
  "academy-common-lib": "/academy-common-lib/static-1.12868",
  "content-assistance-lib": "/content-assistance-lib/static-1.7411",
  "dashboard-lib": "/dashboard-lib/static-1.80521",
  "file-manager-components": "/file-manager-components/static-1.22812",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17804",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17532",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17524",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19429",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8465",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4539",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10673",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8799",
  "user-context": "/user-context/static-1.4868",
  "growth-payments-core": "/growth-payments-core/static-1.24648",
  "reporting-plugins": "/reporting-plugins/static-1.9948",
  "reporting-reports": "/reporting-reports/static-1.66081",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.500",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28805",
  "react-codemirror": "/react-codemirror/static-1.10400",
  "apps-service-types": "/apps-service-types/static-1.3653",
  "oauth-service-types": "/oauth-service-types/static-1.4015",
  "onboarding-scopes": "/onboarding-scopes/static-1.6237",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4435",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7469",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14554",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3428",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8471",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4298",
  "nav-client-types": "/nav-client-types/static-1.2130",
  "purchase-motions-api": "/purchase-motions-api/static-1.5450",
  "signup-constants": "/signup-constants/static-1.18337",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7839",
  "trials-service-types": "/trials-service-types/static-1.3699",
  "card-properties-lib": "/card-properties-lib/static-1.43445",
  "crm-actions": "/crm-actions/static-1.6070",
  "crm-cards-data": "/crm-cards-data/static-1.1156",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42831",
  "customer-data-properties": "/customer-data-properties/static-1.50717",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8741",
  "customer-data-tracking": "/customer-data-tracking/static-1.6655",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3600",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3940",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3494",
  "external-options-client-types": "/external-options-client-types/static-1.3960",
  "react-dnd-compat": "/react-dnd-compat/static-1.4396",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5125",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2844",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1269",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.287",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7299",
  "academy-service-client": "/academy-service-client/static-1.3456",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27874",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8159",
  "video-components-external": "/video-components-external/static-1.10488",
  "video-data-lib": "/video-data-lib/static-1.34146",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8343",
  "payment-link-components": "/payment-link-components/static-1.22867",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9662",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "viral-links-lib": "/viral-links-lib/static-1.6804",
  "data-token-picker": "/data-token-picker/static-1.16000",
  "FileManagerLib": "/FileManagerLib/static-1.38452",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5018",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16922",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8186",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.165",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2980",
  "crm_data": "/crm_data/static-4.91129",
  "crm-links": "/crm-links/static-1.6029",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45341",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14895",
  "crm-fe-perf": "/crm-fe-perf/static-1.22680",
  "calling-global-api": "/calling-global-api/static-1.63562",
  "calling-internal-common": "/calling-internal-common/static-1.31067",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64944",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57238",
  "commerce-products-lib": "/commerce-products-lib/static-1.8778",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.447",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4026",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.407",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47878",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3762",
  "property-value-citations": "/property-value-citations/static-1.1331",
  "pulse": "/pulse/static-1.279",
  "smart-property-lib": "/smart-property-lib/static-1.5777",
  "tiered-pricing": "/tiered-pricing/static-1.788",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10768",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6359",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11353",
  "content-media-compositions": "/content-media-compositions/static-2.15360",
  "media-bridge-lib": "/media-bridge-lib/static-1.18523",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5678",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4862",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3452",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21266",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3619",
  "audio-components": "/audio-components/static-1.5575",
  "FileManagerCore": "/FileManagerCore/static-1.38311",
  "FileManagerImages": "/FileManagerImages/static-1.35963",
  "video-components": "/video-components/static-1.12491",
  "crm_universal": "/crm_universal/static-1.21619",
  "customer-data-email": "/customer-data-email/static-1.17626",
  "calling-error-reporting": "/calling-error-reporting/static-1.31073",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36424",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38783",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18424",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11060",
  "customer-data-content": "/customer-data-content/static-1.26829",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53924",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20808",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17062",
  "project-storage": "/project-storage/static-1.4506",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71055",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5283",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5102",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9497",
  "policy-lib": "/policy-lib/static-1.6555",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10810",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6312",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.163",
  "products-iframe-lib": "/products-iframe-lib/static-1.7245",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9796",
  "directed-graph": "/directed-graph/static-1.711",
  "event-emitter": "/event-emitter/static-1.721",
  "react-tinymce": "/react-tinymce/static-1.54548",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9560",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53674",
  "tinymce-plugins": "/tinymce-plugins/static-1.56788",
  "tinymce-themes": "/tinymce-themes/static-1.55644",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4308",
  "video-embed": "/video-embed/static-1.34980",
  "social-insights-client-types": "/social-insights-client-types/static-1.21265",
  "sequences-lib": "/sequences-lib/static-1.7649",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10121",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17848",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36360",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9727",
  "utility-belt": "/utility-belt/static-1.2316",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21904",
  "products-ui-components": "/products-ui-components/static-1.39297",
  "quotes-client-types": "/quotes-client-types/static-1.37143",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79774",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8862",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6685",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.53940",
  "commerce-products-api": "/commerce-products-api/static-1.1919",
  "SafeStorage": "/SafeStorage/static-1.4178",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55998",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101731",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34940",
  "sales-views-client-types": "/sales-views-client-types/static-1.4066",
  "hub-http-contrib": "/hub-http-contrib/static-1.2818",
  "interframe": "/interframe/static-3.4565",
  "tinymce-data": "/tinymce-data/static-1.39759",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4987",
  "layout-dnd-components": "/layout-dnd-components/static-1.11984",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10959",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13738",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8872",
  "outpost": "/outpost/static-1.3980",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7506",
  "customer-data-associations": "/customer-data-associations/static-1.7109",
  "framework-data-table": "/framework-data-table/static-2.11350",
  "customer-data-rte": "/customer-data-rte/static-1.32384",
  "cv-backend-services": "/cv-backend-services/static-1.1490",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5326",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14154",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4886",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7090",
  "commerce-permissions": "/commerce-permissions/static-1.526",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.283",
  "property-description-translator": "/property-description-translator/static-1.3633",
  "FireAlarmUi": "/FireAlarmUi/static-1.4303",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3970",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3440",
  "totals-ui-components": "/totals-ui-components/static-1.22933",
  "ContentData": "/ContentData/static-1.67622",
  "layout-data-lib": "/layout-data-lib/static-1.9284",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1158",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27652",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3614",
  "advanced-menus-core": "/advanced-menus-core/static-1.14778",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11758",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33357",
  "deal-intel-utils": "/deal-intel-utils/static-1.1162",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14777",
  "simple-menus-lib": "/simple-menus-lib/static-1.16294"
}
};
